import {CheatPlugin} from '../../CheatModuleInterfaces';
import {CheatFiltersController} from './CheatFiltersController';
import {CheatFiltersView} from './CheatFiltersView';

const filters: CheatPlugin = {
    name: 'Filters',
    init: () => [
        CheatFiltersController,
        CheatFiltersView
    ]
};

export default filters;
